import { useAppRouter } from '@my-medication/shared-components/providers/AppRouterProvider';
import { Notification } from '@my-medication/shared-components/shared/Notification';
import { AdminPortalKeys, Namespace } from '@i18n/translations';
import { type FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

const NOTICE_KEYS: Record<string, AdminPortalKeys> = {
  'logout.success': AdminPortalKeys.Login_LogoutSuccess,
  sessionTimeout_success: AdminPortalKeys.Login_SessionTimeoutSuccess,
};

const LoginNotice: FunctionComponent = () => {
  const { t } = useTranslation(Namespace.AdminPortal);
  const { getCurrent } = useAppRouter();
  const notice = getCurrent().query.notice;
  const noticeKey = typeof notice === 'string' ? NOTICE_KEYS[notice] : undefined;

  if (!noticeKey) return null;

  return (
    <div className="flex w-full justify-end">
      <Notification variant="success" className="w-fit!" description={t(noticeKey)} />
    </div>
  );
};

LoginNotice.displayName = 'LoginNotice';

export { LoginNotice };
